var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "custom" },
    [
      _c("Title", {
        attrs: { zhTitle: _vm.pageData.name, enTitle: _vm.pageData.name },
      }),
      _vm.theme == "blue" || _vm.theme == "yellow"
        ? _c(
            "div",
            {
              staticClass: "cards",
              style:
                _vm.customData.length != 3 ? "justify-content: center;" : "",
            },
            _vm._l(_vm.customData, function (item, index) {
              return _c("div", { key: index, staticClass: "card" }, [
                item.icon
                  ? _c("div", { staticClass: "index" }, [
                      _c("img", {
                        attrs: { src: item.icon.replace("/public", "") },
                      }),
                    ])
                  : _vm._e(),
                _c(
                  "div",
                  { class: [_vm.language === "zh" ? "zh_text" : "en_text"] },
                  [_vm._v(_vm._s(item.content))]
                ),
              ])
            }),
            0
          )
        : _c(
            "div",
            {
              staticClass: "cards",
              style:
                _vm.customData.length != 3 ? "justify-content: center;" : "",
            },
            _vm._l(_vm.customData, function (item, index) {
              return _c(
                "div",
                { key: index, staticClass: "card", class: "card" + index },
                [
                  item.icon
                    ? _c(
                        "div",
                        {
                          staticClass: "index",
                          style: { background: _vm.getBackgroundColor(index) },
                        },
                        [
                          _c("img", {
                            attrs: { src: item.icon.replace("/public", "") },
                          }),
                        ]
                      )
                    : _vm._e(),
                  _c(
                    "div",
                    { class: [_vm.language === "zh" ? "zh_text" : "en_text"] },
                    [_vm._v(_vm._s(item.content))]
                  ),
                ]
              )
            }),
            0
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }